export const accommRsvBanquetActions = {
  SET_RSV_VALUE: '@@accommRsv/SET_RSV_VALUE',
};
